<template>
  <NavBar :key="navComponentKey" @refreshNav="refreshNavComponent" />
  <main class="body">
    <router-view/>
  </main>
  <br />
</template>

<script>
 /* eslint-disable */
import NavBar from '@/components/nav/nav_bar.vue'
import checkAutoLogin from "./composables/user/check_auto_login"
import { ref } from 'vue'

export default {
  components: {
    NavBar,
  },
  created() {
    const { checkLogin } = checkAutoLogin()
    checkLogin()
  },
  setup() {
    const isDebug = ref(process.env.NODE_ENV.trim() === 'development')
    const navComponentKey = ref(0)

    const refreshNavComponent = () => {
      navComponentKey.value++
    }

    return {
      navComponentKey,
      refreshNavComponent,
      isDebug,
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/styles/main.scss";
  @import "./styles/ads/monetag_ads.scss";
</style>
